const state = {
  show: false,
  reqToEdit: null,
};

const mutations = {
  setShow(state, isShow) {
    state.show = isShow;
  },

  setReqToEdit(state, req) {
    state.reqToEdit = req;
  },
};

const actions = {};

const getters = {
  show(state) {
    return state.show;
  },

  reqToEdit(state) {
    return state.reqToEdit;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
